(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideoHub = (hub) => {
      if (hub.dataset.videoHubInitialized === 'true') return;

      hub.dataset.videoHubInitialized = 'true';

      const tabs = Array.from(hub.querySelectorAll('[data-video-key]'));
      const panels = Array.from(hub.querySelectorAll('[data-video-panel]'));
      const validKeys = new Set(tabs.map((tab) => tab.dataset.videoKey));
      const defaultKey = hub.dataset.defaultVideo || tabs[0]?.dataset.videoKey;

      const getRequestedKey = () => {
        const requestedKey = new URL(window.location.href)
          .searchParams
          .get('video')
          ?.toLowerCase();

        return validKeys.has(requestedKey) ? requestedKey : defaultKey;
      };

      const activateVideo = (key, updateUrl = false) => {
        const selectedKey = validKeys.has(key) ? key : defaultKey;

        tabs.forEach((tab) => {
          const isActive = tab.dataset.videoKey === selectedKey;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.videoPanel === selectedKey;

          panel.hidden = !isActive;

          const video = panel.querySelector('video');

          if (video) {
            if (isActive) {
              video.preload = 'metadata';
            } else {
              video.pause();
              video.preload = 'none';
            }
          }
        });

        if (updateUrl) {
          const url = new URL(window.location.href);

          if (url.searchParams.get('video') !== selectedKey) {
            url.searchParams.set('video', selectedKey);

            window.history.pushState(
              { video: selectedKey },
              '',
              url
            );
          }
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activateVideo(tab.dataset.videoKey, true);
        });

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();

          let nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          tabs[nextIndex].focus();
          activateVideo(tabs[nextIndex].dataset.videoKey, true);
        });
      });

      activateVideo(getRequestedKey());

      window.addEventListener('popstate', () => {
        activateVideo(getRequestedKey());
      });
    };

    const initializeAllVideoHubs = (root = document) => {
      root.querySelectorAll('[data-video-hub]').forEach(initializeVideoHub);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAllVideoHubs();
      });
    } else {
      initializeAllVideoHubs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllVideoHubs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
